<template>
  <div class="animated fadeIn">
    <b-card :header="detail.appName.ko + ' 사전예약 리스트'">
      <b-navbar>
        <span>{{detail.appName.ko}}의 사전예약 리스트를 조회하거나 등록할 수 있어요.</span>
        <b-navbar-nav class="ml-auto">
          <b-form-group
            label="검색"
            label-for="app"
            label-cols="3"
            horizontal>
            <b-form-input id="app" type="text" autocomplete="app" placeholder="제목으로 검색" v-model="search"></b-form-input>
          </b-form-group>
        </b-navbar-nav>
      </b-navbar>
      <b-table hover striped bordered small fixed responsive="sm" :items="filteredList" :fields="fields" :current-page="currentPage" :per-page="perPage" :show-empty=true empty-text="리스트가 없습니다.">
        <template slot="market" slot-scope="data">
          {{getMarketListString(data.item.marketInfoList, this.codes)}}
        </template>
        <template slot="startTime" slot-scope="data">
          {{data.item.startTime ? data.item.startTime.format('YY.MM.DD HH:mm') : '미등록'}}
        </template>
        <template slot="endTime" slot-scope="data">
          {{data.item.endTime ? data.item.endTime.format('YY.MM.DD HH:mm') : '미등록'}}
        </template>
        <template slot="regTime" slot-scope="data">
          {{data.item.regTime ? data.item.regTime.format('YY.MM.DD HH:mm') : '미등록'}}
        </template>
        <template slot="management" slot-scope="data">
          <b-navbar>
            <b-nav pills>
              <b-link :to="{name: 'pregDetail', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}}" class="mr-2">[보기]</b-link>
              <b-link :to="{name: 'pregEdit', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}}" class="mr-2">[수정]</b-link>
              <b-link :to="{name: 'pregResult', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}}" class="mr-2">[결과조회]</b-link>
              <b-link :to="{ name: 'fixelForm', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}}" v-if="isInhouseLogin()">[픽셀코드]</b-link>
            </b-nav>
          </b-navbar>
        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="filteredList.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
      </nav>
      <b-button class="float-right btn-lg" variant="outline-info" :to="{name: 'pregNew', params: {appMasterId: this.$route.params.appMasterId}}" v-if="isInhouseLogin()">등록</b-button>
    </b-card>

    <guide-info :title="guideInfoTitle" :infoList="guideInfoList"></guide-info>
  </div>
</template>
<script>
import { MODULE_NAME as PREG_MODULE, FETCH_PREGS_BY_APP_MASTER_ID, FETCH_CODES } from '@/store/preg/actions.type'
import { MODULE_NAME as APP_MODULE, FETCH_APP } from '@/store/app/actions.type'
import { mapGetters, mapState, mapMutations } from 'vuex'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import { $getMarketListString, $showModalWithErrorMsg, $isInhouseLogin } from '@/common/util'
import GuideInfo from '@/components/GuideInfo.vue'
export default {
  components: {
    GuideInfo
  },
  data () {
    return {
      guideInfoTitle: '사전예약 가이드 다운로드 안내',
      guideInfoList: [
        {
          link: '//www.dropbox.com/sh/bxrlz50hc8ytetx/AADQ5d5Ak68XRatBdsXNcIJoa?dl=0',
          text: '디자인 가이드'
        },
        {
          link: '//www.dropbox.com/sh/fkfs6nbnykiglxi/AAA1JScDhGMKRxI-X-Loo5lwa?dl=0',
          text: '어드민 이용 가이드'
        },
      ],
      search: '',
      fields: [
        {key: 'appInfo.appName', label: '게임명', class: 'align-middle text-center'},
        {key: 'market', label: '마켓', class: 'align-middle text-center'},
        {key: 'name', label: '제목', class: 'align-middle text-center'},
        {key: 'type', label: '종류', class: 'align-middle text-center'},
        {key: 'startTime', label: '시작', class: 'align-middle text-center', sortable: true},
        {key: 'endTime', label: '종료', class: 'align-middle text-center', sortable: true},
        {key: 'status.text', label: '상태', class: 'align-middle text-center'},
        {key: 'management', label: '사전예약 관리', class: 'align-middle text-center'}
      ],
      currentPage: 1,
      perPage: 5,
      getMarketListString: $getMarketListString,
      isInhouseLogin: $isInhouseLogin.bind(this)
    }
  },
  mounted () {
    this.$store.dispatch(PREG_MODULE + FETCH_CODES)
      .catch($showModalWithErrorMsg.bind(this))
    this.$store.dispatch(PREG_MODULE + FETCH_PREGS_BY_APP_MASTER_ID, this.$route.params.appMasterId)
      .catch($showModalWithErrorMsg.bind(this))
    this.$store.dispatch(APP_MODULE + FETCH_APP, this.$route.params.appMasterId)
      .catch($showModalWithErrorMsg.bind(this))
  },
  computed: {
    filteredList () {
      return this.pregListByAppMasterIdWithMomentAndStatus.filter(item => {
        return item.name.includes(this.search)
      })
    },
    ...mapState('preg', [
      'codes'
    ]),
    ...mapState('app', [
      'detail'
    ]),
    ...mapGetters('preg', [
      'pregListByAppMasterIdWithMomentAndStatus'
    ]),
    ...mapState('auth', [
      'auth'
    ])
  },
  methods: {
    ...mapMutations('ui', [SHOW_MODAL])
  }
}
</script>
